'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";
export function IconTranslation(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M5.215 0a.75.75 0 0 1 .75.75v1.111H9.57a.75.75 0 1 1 0 1.5H8.167A7.797 7.797 0 0 1 6.3 8.203a5.874 5.874 0 0 0 3.09 1.223l1.325-3.034a.75.75 0 0 1 1.374 0l3.739 8.558a.75.75 0 1 1-1.375.6l-1.023-2.34H9.373L8.35 15.55a.75.75 0 1 1-1.374-.6l1.786-4.09a7.379 7.379 0 0 1-3.55-1.607 7.793 7.793 0 0 1-4.257 1.674.75.75 0 1 1-.116-1.495 6.292 6.292 0 0 0 3.313-1.255 7.384 7.384 0 0 1-1.405-2.823.75.75 0 0 1 1.455-.365 5.88 5.88 0 0 0 1.037 2.144 6.296 6.296 0 0 0 1.428-3.772H.86a.75.75 0 0 1 0-1.5h3.605V.75a.75.75 0 0 1 .75-.75zm4.813 11.71h2.746l-1.373-3.144-1.373 3.143z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M8.16 1a1 1 0 0 1 1 1v1.567h5.006a1 1 0 1 1 0 2h-1.969a10.72 10.72 0 0 1-2.593 6.718 8.137 8.137 0 0 0 4.333 1.72l1.838-4.21a1 1 0 0 1 1.833 0L22.764 21.6a1 1 0 0 1-1.833.8l-1.42-3.249h-5.64l-1.42 3.25a1 1 0 1 1-1.832-.801l2.482-5.683a10.142 10.142 0 0 1-4.946-2.233 10.716 10.716 0 0 1-5.875 2.32 1 1 0 0 1-.154-1.995 8.712 8.712 0 0 0 4.615-1.758 10.15 10.15 0 0 1-1.953-3.91 1 1 0 1 1 1.94-.486A8.148 8.148 0 0 0 8.19 10.86a8.72 8.72 0 0 0 2.006-5.293H2.152a1 1 0 1 1 0-2H7.16V2a1 1 0 0 1 1-1zm6.585 16.151h3.893l-1.947-4.457-1.946 4.457z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconTranslation is deprecated and will be archived soon. Use IconTranslation instead.
 */
export function Experimental__IconTranslation(props) {
  return /*#__PURE__*/React.createElement(IconTranslation, props);
}